module.exports = "/_next/static/images/ProcessingDeduplication-4efe306529379765c06f073c4e65bee7.webp";